@if (appearance() === 'menu-item') {
  <a mat-menu-item [href]="href()" rel="noopener noreferrer">
    <mat-icon class="github-icon--menu">
      <app-github-icon />
    </mat-icon>
    <span>Buscar PR</span>
  </a>
} @else {
  <a mat-icon-button [href]="href()" rel="noopener noreferrer" matTooltip="Buscar Pull Request en GitHub">
    <app-github-icon />
  </a>
}
